import type { Lang } from "@noli/core";
import { injectScope } from "./util";
export enum Toast_Words {
  default = "error-unknown",
  paramsError = "params-error",
  codeError = "code-error",
  serverError = "server-error",
  emailRegistered = "email-registered",
  inviterIdError = "inviter-id-format-error",
  emailWrong = "email-wrong",
  unSupportTopic = "unsupport-email-topic",
  passwordInvalid = "password-invalid",
  networkError = "network-error",
  clientError = "client-error",
  commonError = "common-error",
  noAuthError = "no-auth-error",
  loginInfoError = "login-info-error",
  codeSendFail = "code-send-failed",
  accountInvalid = "account-invalid",
  loginSuccess = "login-success",
  loginFailed = "login-failed",
  registerSuccess = "register-success",
  registerFailed = "register-failed",
  changeSuccess = "change-success",
  changeFailed = "change-failed",
  usernameSensitiveCheckFailed = "username-sensitive-check-failed",
  accountOrPasswordError = "account-or-password-error",
  sendEmailCodeError = "send-email-code-error",
  nickNameLenError = "nick-name-len-error",
  loginError = "login-error",
  phoneCodeLimitError = "phone-code-limit-error",
  sendSMSError = "send-sms-error",
  smsCodeMistakeError = "sms-code-mistake-error",
  wechatCodeError = "wechat-code-error",
  phoneRegistered = "phone-registered",
  phoneRegisterFailError = "phone-register-fail-error",
  emailNotExist = "email-not-exist",
  phoneNotExist = "phone-not-exist",
  passwordResetError = "password-reset-error",
  getQrCodeError = "get-qr-code-error",
  invalidQrCode = "invalid-qr-code",
  qrCodeNotScan = "qr-code-not-scan",
  notFoundUserInfoByPhone = "not-found-userinfo-by-phone",
  phoneBoundWechat = "phone-bound-wechat",
  bindWechatError = "bind-wechat-error",
  notFoundUserInfoByMini = "not-found-userinfo-by-mini",
  bindPhoneFailed = "bind-phone-failed",
  userNotExist = "user-not-exist",
  getPhoneByWechatError = "get-phone-by-wechat-error",
  loginInfoInvalid = "login-info-invalid",
  //画册
  album_error_4000 = "album_error_4000", // 画册创建失败
  album_error_4004 = "album_error_4004", // 画册不存在
  album_error_4005 = "album_error_4005", // 画册查询失败
  album_error_4006 = "album_error_4006", // 包含默认画册
  album_error_4007 = "album_error_4007", // 移动图片至默认画册失败
  album_error_4008 = "album_error_4008", // 删除画册图片失败
  album_error_4009 = "album_error_4009", // 添加画册图片失败
  album_error_4010 = "album_error_4010", // 更新画册失败
  album_error_4011 = "album_error_4011", // 画册图片查询失败
  album_error_4012 = "album_error_4012", // 画册图片不存在
  album_error_4013 = "album_error_4013", // 画册图片删除失败
  album_error_4014 = "album_error_4014", // 画册图片移动失败
  album_error_4015 = "album_error_4015", // 画册名称已存在
  album_error_4016 = "album_error_4016", // 画册名称包含敏感词
  album_error_4017 = "album_error_4017", // 画册参数错误
  album_error_4018 = "album_error_4018", // 画册删除失败
  album_error_4019 = "album_error_4019", // 画册重命名失败
  imageNotExist = "imageNotExist",
  ERR_BALANCE_NOT_ENOUGH = "ERR_BALANCE_NOT_ENOUGH", // 画力星余额不足
  ERR_CLOUD_STORAGE_DATA_EXPIRED = "ERR_CLOUD_STORAGE_DATA_EXPIRED",
  monkey_sensitive_7003 = "monkey_sensitive_7003",
}

injectScope("toast", Toast_Words);

export const toastLangRecords: Record<Lang, Record<Toast_Words, string>> = {
  zh: {
    [Toast_Words.default]: "未知错误，错误码:$",
    [Toast_Words.paramsError]: "参数解析失败",
    [Toast_Words.codeError]: "验证码错误",
    [Toast_Words.serverError]: "内部错误",
    [Toast_Words.emailRegistered]: "邮箱已注册",
    [Toast_Words.inviterIdError]: "邀请人ID格式错误",
    [Toast_Words.emailWrong]: "邮箱注册失败，请检查邮箱是否正确",
    [Toast_Words.unSupportTopic]: "不支持的邮箱主题",
    [Toast_Words.passwordInvalid]: "密码格式不正确",
    [Toast_Words.networkError]: "网络错误，请检查网络状态后重试",
    [Toast_Words.clientError]: "客户端错误",
    [Toast_Words.commonError]: "操作失败,请稍后再试",
    [Toast_Words.noAuthError]: "未登录，请登录后重试",
    [Toast_Words.loginInfoError]: "凭证失效或操作频繁，请稍后重试",
    [Toast_Words.codeSendFail]: "验证码发送失败",
    [Toast_Words.accountInvalid]: "请输入正确的账号",
    [Toast_Words.registerSuccess]: "注册成功",
    [Toast_Words.registerFailed]: "注册失败",
    [Toast_Words.loginSuccess]: "登录成功",
    [Toast_Words.loginFailed]: "登录失败",
    [Toast_Words.changeSuccess]: "修改成功",
    [Toast_Words.changeFailed]: "修改失败",
    [Toast_Words.usernameSensitiveCheckFailed]: "您的用户名中含有敏感词汇，请更正后重试",
    [Toast_Words.accountOrPasswordError]: "账号或密码错误，请更正后重试",
    [Toast_Words.sendEmailCodeError]: "验证码发送失败",
    [Toast_Words.nickNameLenError]: "用户名长度非法",
    [Toast_Words.loginError]: "登录失败",
    [Toast_Words.phoneCodeLimitError]: "超过验证码发送次数上线",
    [Toast_Words.sendSMSError]: "验证码发送失败",
    [Toast_Words.smsCodeMistakeError]: "验证码错误，请核对后重试",
    [Toast_Words.wechatCodeError]: "微信码获取凭证失败",
    [Toast_Words.phoneRegistered]: "手机号已注册",
    [Toast_Words.phoneRegisterFailError]: "手机号注册失败",
    [Toast_Words.emailNotExist]: "邮箱不存在",
    [Toast_Words.phoneNotExist]: "手机号不存在",
    [Toast_Words.passwordResetError]: "密码重置失败",
    [Toast_Words.getQrCodeError]: "获取二维码错误",
    [Toast_Words.invalidQrCode]: "等待时间过长，二维码已失效，请刷新后重新扫码登录",
    [Toast_Words.qrCodeNotScan]: "二维码未扫描",
    [Toast_Words.notFoundUserInfoByPhone]: "手机号未查询到相关用户信息",
    [Toast_Words.phoneBoundWechat]: "该手机号已绑定微信",
    [Toast_Words.bindWechatError]: "绑定微信号失败",
    [Toast_Words.notFoundUserInfoByMini]: "小程序未查询到用户信息",
    [Toast_Words.bindPhoneFailed]: "手机绑定失败",
    [Toast_Words.userNotExist]: "用户不存在",
    [Toast_Words.getPhoneByWechatError]: "微信获取手机号信息失败",
    [Toast_Words.loginInfoInvalid]: "账号或密码格式不正确",
    // 画册
    [Toast_Words.album_error_4000]: "画册创建失败",
    [Toast_Words.album_error_4004]: "画册不存在",
    [Toast_Words.album_error_4005]: "画册查询失败",
    [Toast_Words.album_error_4006]: "包含默认画册",
    [Toast_Words.album_error_4007]: "移动图片至默认画册失败",
    [Toast_Words.album_error_4008]: "删除画册图片失败",
    [Toast_Words.album_error_4009]: "添加画册图片失败",
    [Toast_Words.album_error_4010]: "更新画册失败",
    [Toast_Words.album_error_4011]: "画册图片查询失败",
    [Toast_Words.album_error_4012]: "画册图片不存在",
    [Toast_Words.album_error_4013]: "画册图片删除失败",
    [Toast_Words.album_error_4014]: "画册图片移动失败",
    [Toast_Words.album_error_4015]: "画册名称已存在",
    [Toast_Words.album_error_4016]: "画册名称包含敏感词",
    [Toast_Words.album_error_4017]: "画册参数错误",
    [Toast_Words.album_error_4018]: "画册删除失败",
    [Toast_Words.album_error_4019]: "画册重命名失败",
    [Toast_Words.imageNotExist]: "图片不存在",
    [Toast_Words.ERR_BALANCE_NOT_ENOUGH]: "画力星余额不足",
    [Toast_Words.ERR_CLOUD_STORAGE_DATA_EXPIRED]: "",
    [Toast_Words.monkey_sensitive_7003]: "您的输入存在敏感信息",
  },
  en: {
    [Toast_Words.default]: "Unknown Error, error code:$",
    [Toast_Words.paramsError]: "Params error",
    [Toast_Words.codeError]: "Your email code is wrong, please try again",
    [Toast_Words.serverError]: "Internal error",
    [Toast_Words.emailRegistered]: "This Email has already been registered",
    [Toast_Words.inviterIdError]: "Inviter ID format error",
    [Toast_Words.emailWrong]: "Register email is wrong, please try again",
    [Toast_Words.unSupportTopic]: "Unsupported topic",
    [Toast_Words.passwordInvalid]: "Password invalid",
    [Toast_Words.networkError]: "Network error, please check your network status",
    [Toast_Words.clientError]: "Client error occurred",
    [Toast_Words.commonError]: "Some error occurred, please try again later",
    [Toast_Words.noAuthError]: "Please retry after sign in",
    [Toast_Words.loginInfoError]: "Code expire or operating too much, please try again later",
    [Toast_Words.codeSendFail]: "The verification code fails to be sent",
    [Toast_Words.accountInvalid]: "The account is invalid",
    [Toast_Words.registerSuccess]: "Registered successfully",
    [Toast_Words.registerFailed]: "Registered failed",
    [Toast_Words.loginSuccess]: "Sign in successfully",
    [Toast_Words.loginFailed]: "Sign in failed",
    [Toast_Words.changeSuccess]: "Update successfully",
    [Toast_Words.changeFailed]: "Update failed",
    [Toast_Words.usernameSensitiveCheckFailed]:
      "Your username has sensitive word, please change another one and retry",
    [Toast_Words.accountOrPasswordError]: "Wrong account or password",
    [Toast_Words.sendEmailCodeError]: "Fail to send code",
    [Toast_Words.nickNameLenError]: "Invalid username length",
    [Toast_Words.loginError]: "Sign in failed",
    [Toast_Words.phoneCodeLimitError]: "Send code too much times",
    [Toast_Words.sendSMSError]: "Code send failed",
    [Toast_Words.smsCodeMistakeError]: "Wrong code, please check and retry",
    [Toast_Words.wechatCodeError]: "Get wechat token failed",
    [Toast_Words.phoneRegistered]: "This phone has already been registered",
    [Toast_Words.phoneRegisterFailError]: "Register failed",
    [Toast_Words.emailNotExist]: "This email not exist",
    [Toast_Words.phoneNotExist]: "This phone number not exist",
    [Toast_Words.passwordResetError]: "Password reset failed",
    [Toast_Words.getQrCodeError]: "Can not get qrCode",
    [Toast_Words.invalidQrCode]: "QrCode was invalid, please refresh and retry",
    [Toast_Words.qrCodeNotScan]: "QrCode not scan",
    [Toast_Words.notFoundUserInfoByPhone]: "Can not found user info by phone",
    [Toast_Words.phoneBoundWechat]: "This phone has bound another wechat",
    [Toast_Words.bindWechatError]: "Bound wechat failed",
    [Toast_Words.notFoundUserInfoByMini]: "Can not found user info by mini program",
    [Toast_Words.bindPhoneFailed]: "Phone bound failed",
    [Toast_Words.userNotExist]: "User not exist",
    [Toast_Words.getPhoneByWechatError]: "Get phone info by wechat error",
    [Toast_Words.loginInfoInvalid]: "Invalid login info, please check and retry",
    // 画册
    [Toast_Words.album_error_4000]: "Create album failed",
    [Toast_Words.album_error_4004]: "Album not exist",
    [Toast_Words.album_error_4005]: "Search album failed",
    [Toast_Words.album_error_4006]: "Can not contain default album",
    [Toast_Words.album_error_4007]: "Move to default album failed",
    [Toast_Words.album_error_4008]: "Delete album image failed",
    [Toast_Words.album_error_4009]: "Add image to album failed",
    [Toast_Words.album_error_4010]: "Update album failed",
    [Toast_Words.album_error_4011]: "Search image of this album failed",
    [Toast_Words.album_error_4012]: "The image is not exist",
    [Toast_Words.album_error_4013]: "Delete image failed",
    [Toast_Words.album_error_4014]: "Move image failed",
    [Toast_Words.album_error_4015]: "Album name has existed",
    [Toast_Words.album_error_4016]: "Album name can not contain sensitive words",
    [Toast_Words.album_error_4017]: "Album parameters error",
    [Toast_Words.album_error_4018]: "Delete album failed",
    [Toast_Words.album_error_4019]: "Rename album failed",
    [Toast_Words.imageNotExist]: "Image not exist",
    [Toast_Words.ERR_BALANCE_NOT_ENOUGH]: "Heart Coins not enough",
    [Toast_Words.ERR_CLOUD_STORAGE_DATA_EXPIRED]: "",
    [Toast_Words.monkey_sensitive_7003]: "Your prompt can not pass sensitive word check",
  },
};

// 错误码映射
export const ErrorCode2LangKeyMap: {
  [key: number | string]: Toast_Words;
} = {
  1: Toast_Words.networkError,
  404: Toast_Words.clientError,
  4001: Toast_Words.paramsError,
  4002: Toast_Words.loginInfoError,
  4003: Toast_Words.loginInfoError,
  502: Toast_Words.serverError,
  5005: Toast_Words.serverError,
  1000: Toast_Words.paramsError,
  1001: Toast_Words.codeError,
  1002: Toast_Words.serverError,
  1003: Toast_Words.emailRegistered,
  1004: Toast_Words.inviterIdError,
  1005: Toast_Words.emailWrong,
  1006: Toast_Words.unSupportTopic,
  1007: Toast_Words.passwordInvalid,
  1008: Toast_Words.accountOrPasswordError, // 密码错误
  1009: Toast_Words.accountOrPasswordError, // 账号错误
  1010: Toast_Words.sendEmailCodeError,
  1011: Toast_Words.nickNameLenError,
  1012: Toast_Words.loginError,
  1013: Toast_Words.phoneCodeLimitError,
  1014: Toast_Words.sendSMSError,
  1015: Toast_Words.smsCodeMistakeError,
  1016: Toast_Words.wechatCodeError,
  1017: Toast_Words.phoneRegistered,
  1018: Toast_Words.phoneRegisterFailError,
  1019: Toast_Words.emailNotExist,
  1020: Toast_Words.phoneNotExist,
  1021: Toast_Words.passwordResetError,
  1022: Toast_Words.getQrCodeError,
  1023: Toast_Words.invalidQrCode,
  1024: Toast_Words.qrCodeNotScan,
  1025: Toast_Words.notFoundUserInfoByPhone,
  1026: Toast_Words.phoneBoundWechat,
  1027: Toast_Words.bindWechatError,
  1028: Toast_Words.notFoundUserInfoByMini,
  1029: Toast_Words.bindPhoneFailed,
  1030: Toast_Words.userNotExist,
  1031: Toast_Words.getPhoneByWechatError,
  400: Toast_Words.commonError,
  401: Toast_Words.commonError,
  405: Toast_Words.commonError,
  9000: Toast_Words.commonError,
  //画册相关
  4000: Toast_Words.album_error_4000, // 画册创建失败
  4004: Toast_Words.album_error_4004, // 画册不存在
  4005: Toast_Words.album_error_4005, // 画册查询失败
  4006: Toast_Words.album_error_4006, // 包含默认画册
  4007: Toast_Words.album_error_4007, // 移动图片至默认画册失败
  4008: Toast_Words.album_error_4008, // 删除画册图片失败
  4009: Toast_Words.album_error_4009, // 添加画册图片失败
  4010: Toast_Words.album_error_4010, // 更新画册失败
  4011: Toast_Words.album_error_4011, // 画册图片查询失败
  4012: Toast_Words.album_error_4012, // 画册图片不存在
  4013: Toast_Words.album_error_4013, // 画册图片删除失败
  4014: Toast_Words.album_error_4014, // 画册图片移动失败
  4015: Toast_Words.album_error_4015, // 画册名称已存在
  4016: Toast_Words.album_error_4016, // 画册名称包含敏感词
  4017: Toast_Words.album_error_4017, // 画册参数错误
  4018: Toast_Words.album_error_4018, // 画册删除失败
  4019: Toast_Words.album_error_4019, // 画册重命名失败
  1052: Toast_Words.imageNotExist,
  7003: Toast_Words.monkey_sensitive_7003,
  //默认
  default: Toast_Words.default,
  // 根据msg判断的
  ERR_BALANCE_NOT_ENOUGH: Toast_Words.ERR_BALANCE_NOT_ENOUGH,
  ERR_CLOUD_STORAGE_DATA_EXPIRED: Toast_Words.ERR_CLOUD_STORAGE_DATA_EXPIRED,
};
